import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody } from "reactstrap";

//Import Charts
import ReactApexChart from "react-apexcharts";
import "./dashboard.scss";
import { lkprimary, lkgreen } from "./styles";
import { computeRevenue } from "../Utility/utilsFunctions";
import { MONTHS } from "../Utility/Constants";
import Spinner from "../Utility/Spinner";
import { connect } from "react-redux";

const RevenueAnalytics = (props) => {
  const { transactionData, dbFilter, layoutType } = props;
  const { dateRange, location } = dbFilter;
  const [revenueAnalyticsData, setRevenueAnalyticsData] = useState([]);

  let revenueAnalyticsDataYear1 = Array(12).fill(0);
  let revenueAnalyticsDataYear2 = Array(12).fill(0);
  const options = {
    chart: {
      toolbar: {
        show: false,
      },
    },
    stroke: {
      width: [0, 1],
      curve: "smooth",
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: layoutType === "vertical" ? "20pt" : "6px",
      },
    },
    dataLabels: {
      enabled: false,
    },

    legend: {
      show: false,
    },
    xaxis: {
      labels: {
        style: {
          fontSize: layoutType === "vertical" ? "13px" : "10px",
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: layoutType === "vertical" ? "13px" : "10px",
        },
      },
    },
    colors: [lkprimary, lkgreen],
    labels: MONTHS,
  };

  // calculate revenue analytics
  useEffect(() => {
    const year1 = new Date(dateRange[0]).getFullYear();
    const year2 = new Date(dateRange[1]).getFullYear();

    if (!transactionData && transactionData?.length === 0) {
      return;
    }
    console.log("selectedLocationId: RevenueAnalytics", location);

    let chargersInSelectedLocation = [];
    if (location?.length > 0) {
      // chargersInSelectedLocation = props.chargerToLocationMap[location] || [];
      const chargersInSelectedLoc = props.chargerToLocationMap[location] || [];
      chargersInSelectedLocation = chargersInSelectedLoc?.map((item) => item?.id) || [];
    }
    console.log("chargersInSelectedLocation: RevenueAnalytics", chargersInSelectedLocation);

    const startDate = new Date(dateRange[0]).getTime();
    const endDate = new Date(dateRange[1]).getTime();

    // filter the transaction for the selected date range
    let filteredTransaction = transactionData?.filter((trans) => {
      const statusTime = new Date(trans.startTime).getTime();
      if (location?.length === 0) {
        return statusTime >= startDate && statusTime <= endDate;
      }
      return statusTime >= startDate && statusTime <= endDate && chargersInSelectedLocation?.includes(trans?.chargerId);
    });
    if (year1 !== year2) {
      filteredTransaction.forEach((item) => {
        const { startTime, meterStart, meterStop, perUnitRate } = item;
        const transactionDate = new Date(startTime);
        const year = transactionDate.getFullYear();
        const monthIndex = new Date(startTime).getMonth();
        const revenue = computeRevenue(parseInt(meterStart, 10), parseInt(meterStop, 10), 10);

        if (year === year1) {
          revenueAnalyticsDataYear1[monthIndex] += Math.floor(revenue);
        } else if (year === year2) {
          revenueAnalyticsDataYear2[monthIndex] += Math.floor(revenue);
        }
      });
      const data = [
        {
          name: year1,
          type: "column",

          data: revenueAnalyticsDataYear1,
        },
        {
          name: year2,
          type: "column",

          data: revenueAnalyticsDataYear2,
        },
      ];
      setRevenueAnalyticsData(data);
    } else {
      filteredTransaction.forEach((item) => {
        const { startTime, meterStart, meterStop, perUnitRate } = item;
        const monthIndex = new Date(startTime).getMonth();
        const revenue = computeRevenue(parseInt(meterStart, 10), parseInt(meterStop, 10), 10);
        revenueAnalyticsDataYear1[monthIndex] += Math.floor(revenue);
      });
      const data = [
        {
          name: year1,
          type: "column",

          data: revenueAnalyticsDataYear1,
        },
      ];
      setRevenueAnalyticsData(data);
    }
  }, [dateRange, location, transactionData]);

  return (
    <React.Fragment>
      <Card>
        {revenueAnalyticsData && revenueAnalyticsData?.length > 0 ? (
          <>
            {" "}
            <CardBody className={`${layoutType === "horizontal" && "m-0 p-0"}`}>
              <h4 className={`card-title ${layoutType === "vertical" ? "mb-4" : "m-2"}`}>Revenue Analytics</h4>

              <div className="m-0 p-0">
                <div id="line-column-chart" className="apex-charts" dir="ltr">
                  <ReactApexChart options={options} series={revenueAnalyticsData} type="line" height="280" />
                </div>
              </div>
            </CardBody>
            {layoutType === "vertical" && (
              <CardBody className="border-top text-center">
                <Row>
                  <Col sm={4}>
                    <div className="d-inline-flex">
                      <h5 className="mr-2">₹ 15,450</h5>
                      <div className="text-danger">
                        <i className="mdi mdi-menu-down font-size-14"> </i>3.43%
                      </div>
                    </div>
                    <p className="text-muted text-truncate mb-0">This month</p>
                  </Col>

                  <Col sm={4}>
                    <div className="mt-4 mt-sm-0">
                      <p className="mb-2 text-muted text-truncate">
                        <i className="mdi mdi-circle text-primary font-size-10 mr-1"></i> This Year :
                      </p>
                      <div className="d-inline-flex">
                        <h5 className="mb-0 mr-2">₹ 30,950</h5>
                        <div className="text-success">
                          <i className="mdi mdi-menu-up font-size-14"> </i>10.53%
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col sm={4}>
                    <div className="mt-4 mt-sm-0">
                      <p className="mb-2 text-muted text-truncate">
                        <i className="mdi mdi-circle text-success font-size-10 mr-1"></i> Previous Year :
                      </p>
                      <div className="d-inline-flex">
                        <h5 className="mb-0">₹ 1,85,914</h5>
                      </div>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            )}
          </>
        ) : (
          <div style={{ height: "300px" }}>
            <Spinner />
          </div>
        )}
      </Card>
    </React.Fragment>
  );
};
const mapStateToProps = (state) => ({
  chargerToLocationMap: state?.sharedData?.chargerToLocationMap,
  layoutType: state.Layout.layoutType,
});

export default connect(mapStateToProps)(RevenueAnalytics);
